module.exports = __webpack_public_path__ + "static/media/arrow.300a1738.png";